import { Controller } from "@hotwired/stimulus"

// P32/P45 — La cérémonie du tirage : les paires tombent dans le tableau
// une par une. Le résultat est déjà établi côté serveur et déjà écrit
// dans la page ; ce contrôleur ne fait que donner le rythme — sans
// JavaScript, tout s'affiche d'un coup et reste exact.
//
// Une même place apparaît à deux endroits (le tableau sur grand écran,
// la liste sur petit écran) : les deux portent le même rang, et
// s'allument ensemble.
export default class extends Controller {
  static values = { cadence: { type: Number, default: 650 }, total: Number }

  connect() {
    this.minuteries = []
    const cartes = Array.from(this.element.querySelectorAll("[data-tirage-reveal]"))
    if (cartes.length === 0) return

    this.compteur = this.element.querySelector("[data-tirage-compteur]") ||
      document.querySelector("[data-tirage-compteur]")

    if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) return

    // Un pas par rang : le tableau et la liste s'allument ensemble.
    const parRang = new Map()
    cartes.forEach((carte) => {
      const rang = Number(carte.dataset.tirageOrdre || 0)
      if (!parRang.has(rang)) parRang.set(rang, [])
      parRang.get(rang).push(carte)
      carte.classList.add("est-cache")
    })

    const rangs = Array.from(parRang.keys()).sort((a, b) => a - b)
    if (this.compteur) this.compteur.textContent = "0"

    rangs.forEach((rang, index) => {
      const minuterie = setTimeout(() => {
        parRang.get(rang).forEach((carte) => {
          carte.classList.remove("est-cache")
          carte.classList.add("est-revele")
        })
        if (this.compteur) this.compteur.textContent = String(index + 1)
      }, index * this.cadenceValue)
      this.minuteries.push(minuterie)
    })
  }

  disconnect() {
    this.minuteries.forEach((minuterie) => clearTimeout(minuterie))
    this.minuteries = []
  }
}
